import { RELATIONSHIP_TYPES, type RelationshipType } from '@atbash-labs/ontology-core'

export interface RelationshipRenderer {
  kind: 'bespoke-panel' | 'generic-connections'
  preservesProps: boolean
}

const genericConnections: RelationshipRenderer = {
  kind: 'generic-connections',
  preservesProps: true
}

export const RELATIONSHIP_RENDERERS: Readonly<Record<RelationshipType, RelationshipRenderer>> = {
  ...(Object.fromEntries(RELATIONSHIP_TYPES.map((type) => [type, genericConnections])) as Record<
    RelationshipType,
    RelationshipRenderer
  >),
  FEEDS: { kind: 'bespoke-panel', preservesProps: true },
  HAS_PART: { kind: 'bespoke-panel', preservesProps: true },
  REQUIRES_UTILITY: { kind: 'bespoke-panel', preservesProps: true },
  CONNECTS_TO: { kind: 'bespoke-panel', preservesProps: true },
  PROCEDURE_FOR: { kind: 'bespoke-panel', preservesProps: true },
  REQUIRES_PART: { kind: 'bespoke-panel', preservesProps: true },
  REQUIRES_SKILL_LEVEL: { kind: 'bespoke-panel', preservesProps: true },
  APPLIES_TO_PRODUCT: { kind: 'bespoke-panel', preservesProps: true },
  SUPPLIED_BY: { kind: 'bespoke-panel', preservesProps: true },
  MANUFACTURED_BY: { kind: 'bespoke-panel', preservesProps: true },
  EXHIBITS_SYMPTOM: { kind: 'bespoke-panel', preservesProps: true },
  INDUCES: { kind: 'bespoke-panel', preservesProps: true },
  CAUSED_BY: { kind: 'bespoke-panel', preservesProps: true },
  LOCATED_IN: { kind: 'bespoke-panel', preservesProps: true },
  USES_EQUIPMENT: { kind: 'bespoke-panel', preservesProps: true },
  RAN_ON: { kind: 'bespoke-panel', preservesProps: true },
  EXECUTED_ON: { kind: 'bespoke-panel', preservesProps: true },
  READS_TAG: { kind: 'bespoke-panel', preservesProps: true },
  WRITES_TAG: { kind: 'bespoke-panel', preservesProps: true },
  CALCULATED_BY: { kind: 'bespoke-panel', preservesProps: true },
  MAPS_TO_TAG: { kind: 'bespoke-panel', preservesProps: true },
  MAPS_TO_ROBOT_SIGNAL: { kind: 'bespoke-panel', preservesProps: true },
  SUPERVISES: { kind: 'bespoke-panel', preservesProps: true },
  DEFINES: { kind: 'bespoke-panel', preservesProps: true },
  CALLS_JOB: { kind: 'bespoke-panel', preservesProps: true },
  READ_BY: { kind: 'bespoke-panel', preservesProps: true },
  WRITTEN_BY: { kind: 'bespoke-panel', preservesProps: true },
  USED_BY: { kind: 'bespoke-panel', preservesProps: true },
  REQUIRES_LABOR: { kind: 'bespoke-panel', preservesProps: true },
  HAS_CREW_REQUIREMENT: { kind: 'bespoke-panel', preservesProps: true },
  HAS_LINE_OPERATION: { kind: 'bespoke-panel', preservesProps: true },
  RECOVERS: { kind: 'bespoke-panel', preservesProps: true },
  FALLBACK_FOR: { kind: 'bespoke-panel', preservesProps: true },
  COVERS: { kind: 'bespoke-panel', preservesProps: true },
  STAFFED_BY: { kind: 'bespoke-panel', preservesProps: true },
  SCHEDULED_BY: { kind: 'bespoke-panel', preservesProps: true },
  TRIGGERED_BY: { kind: 'bespoke-panel', preservesProps: true }
}
